import { styled } from "@mui/material/styles";
import type { CSSProperties } from "react";
// import { forwardRef } from "react";
import IcoMoon, { type IconProps } from "react-icomoon";
import iconSet from "../../styles/icon-json/selection.json";

/**
 * react-icomoon does NOT implement forwardRefs with the IcoMoon
 * component, if you need a ref to the icon place it in a box
 * and get a reference for the wrapper...
 */

// const _Icon = forwardRef<SVGElement, IconProps>(
//   function _Icon(
//     props,
//     ref
//   ) {
//     return (
//       <IcoMoon
//         className={ "icon" }
//         iconSet={ iconSet }
//         ref={ ref }
//         { ...props }
//       />
//     );
//   }
// );

// export const Icon = styled(_Icon)(({ color }) => ({
//   path: {
//     fill: color
//   }
// }));

type BaseIcoMoonProps = IconProps & {
  className?: string;
};

const IcoMoonComponent = (IcoMoon as { default?: typeof IcoMoon }).default ?? IcoMoon;

const BaseIcoMoon = ({ className, ...props }: BaseIcoMoonProps) => (
  <IcoMoonComponent
    className={ ["icon", className].filter(Boolean).join(" ") }
    iconSet={ iconSet }
    { ...props }
  />
);

const StyledIcoMoon = styled(BaseIcoMoon)(({ color }) => ({
  "&.icon path": {
    fill: color
  }
}));

interface ExtendedIconProps extends IconProps {
  sx?: CSSProperties;
}

export function Icon (props: ExtendedIconProps){
  return(
    <StyledIcoMoon { ...props } />
  );
}
